/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Household_Teen_Confirm_DescriptionInputs */

const fr_household_teen_confirm_description = /** @type {(inputs: Household_Teen_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un ado ne peut pas suivre un cours adulte sans parent inscrit. En te désinscrivant, tu désinscris aussi ${i?.names}.`)
};

/**

* @param {Household_Teen_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_teen_confirm_description = /** @type {((inputs: Household_Teen_Confirm_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Teen_Confirm_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_teen_confirm_description(inputs)
});